import apiHelper from '../../Components/helpers/utils/apiHelper'
import * as actionType from '../../redux/actionType';
import { loaderEnd, loaderStart } from '../services';

export const getFlyerPdf = (params) => {
  return async dispatch => {
    try {
      dispatch(loaderStart())
      let response = await apiHelper(`/V1/flyer`, 'get', params, {});
      if (response.status === 200) {
        dispatch(getFlyerPdfSuccess(response.data));
        dispatch(loaderEnd())
      }
    } catch (error) {

    }
  }
};

// get addresses
export const getFlyerPdfSuccess = (data) => {
  return {
    type: actionType.GET_FLYER_PDF,
    payload: data
  }
}
